module.exports = __webpack_public_path__ + "b417c286c6d21ea0900d74af00e2fca0.pdf";